import {connect} from 'react-redux';
import {denormalize} from 'normalizr';

import {schema} from '../../../../../state/schema';
import {loadCareGuideHelperTags, deleteCareGuideHelperTag} from '../../../../../state/modules/careGuideHelperTags/actions';
import {sendMessage} from '../../../../../state/actions';
import CareGuideHelperTagsList from '../components/CareGuideHelperTagsList';

const mapStateToProps = (state, ownProps) => {

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.careGuideHelperTags.getIn(['pages', order, limit, page]);

  return {
    list: result 
      ? result.map(x => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['careGuideHelperTags', x]),
              schema.careGuideHelperTag,
              state.entities.toJS()
            )
          };
        }).toArray()
      : [],
    isLoading: state.careGuideHelperTags.get('isLoading'),
    total: state.careGuideHelperTags.get('total'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadCareGuideHelperTags(page, limit, order, filter, cb));
    },
    remove: (id, cb) => {
      dispatch(deleteCareGuideHelperTag(id, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const CareGuideHelperTagsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CareGuideHelperTagsList);

export default CareGuideHelperTagsListContainer;
